import HavePay from "@/views/outsidesettle/havepay/HavePay"
export const havepay = {
    path: '/havepay',
    name: 'HavePay',
    component: HavePay
  }


// WEBPACK FOOTER //
// ./src/router/index/outsidesettle/havepay/index.js